export default {
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},
	gridUseYnList_: ({ gridUseYnList }) => gridUseYnList
};
